const invertedMessages = {
  'Are you sure you want to enable ID proofing?':
    'external.idp.enable.confirmation',
  'Third party cost may be incurred.': 'external.idp.enable.subtext',
  Apply: 'external.idp.apply',
  Cancel: 'external.idp.cancel',
  'Are you sure you want to disable ID proofing?': 'external.idp.disable.title',
  Disable: 'external.idp.disable',
  Enable: 'external.idp.enable',
  'Data Fetch Error': 'external.idp.dataError',
  'ID Proofing': 'external.idp.idProofing',
  'Set Up': 'external.idpSetup.setUpBtn',
  Disabled: 'external.idp.status.disabled',
  Enabled: 'external.idp.status.enabled',
  Settings: 'external.idp.tab.settings',
};

export default invertedMessages;
